
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { IDynamicElement, IText } from '../_shared/models';
import { HeadingSize } from '../_shared/types';
import { GridComponent } from '../grid/grid.component';
import { HeadingComponent } from '../heading/heading.component';
import { TextHtmlComponent } from '../text-html/text-html.component';

@Component({
    selector: 'sirius-text-body',
    templateUrl: './text-body.component.html',
    styleUrls: ['./text.default.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GridComponent, HeadingComponent, TextHtmlComponent]
})
export class TextBodyComponent implements OnInit, IDynamicElement {
    @Input() config?: IText;
    @Input() title = '';
    @Input() headingSize: HeadingSize = 'l';
    @Input() textHtml = '';

    ngOnInit(): void {
        if (this.config) {
            this.title = this.config.title;
            this.headingSize = this.config.headingSize;
            this.textHtml = this.config.textHtml;
        }
    }
}
